import { RailsItem } from '~/typings/services/rails/item';

export default function ItemDescription({ item }: { item: RailsItem }) {
  return (
    <p className="mb-4 whitespace-pre-line break-words text-sm">
      {item.description}
    </p>
  );
}
